/**
 * Return a not NaN number Aka number or default
 *
 * @param {number} value
 * @param {number} defaultValue
 * @returns {number}
 */
export default (value, defaultValue = 0) => (Number.isNaN(value) ? defaultValue : value);
